import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

//TODO Ajouter un petit icone de scanner par defaut

function ScannerInput({ onChange, onKeyDown=(e)=>{ }, value, error, label, disabled = false }) {
    const inputRef = useRef(null);

    return (
      <div className="input-field">
        <input
          disabled={disabled}
          ref={inputRef}
          onChange={(event) => onChange(event.target.value)}
          onFocus={(e) => e.target.select()}
          onKeyDown={(event) => onKeyDown(event)}
          value={value}
          error={error}
          type="text"
          autoFocus
          className={classnames("", {
            invalid: error,
          })}
        />
        <label onClick={() => inputRef.current.focus()}>{label}</label>
        <span className="red-text">
          {error}
        </span>
      </div>
    );
  }
  
  ScannerInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    error: PropTypes.string,
    label: PropTypes.string.isRequired,
  };
  
  export default ScannerInput;